const parse = (raw) =>
  raw.split(/\r?\n/).flatMap((line) => {
    const i = line.indexOf(':');
    if (i < 0) return [];
    const city = line.slice(0, i).trim();
    const ranges = line.slice(i + 1).split(',').map((p) => p.trim()).filter(Boolean).map((p) => {
      const [a, b = a] = p.split('-').map((n) => Number(n.trim()));
      return { a, b };
    });
    return city ? [{ city, key: city.toLowerCase().replace(/[^a-z0-9]/g, ''), ranges }] : [];
  });

const check = (box) => {
  const input = box.querySelector('[data-apts-pc-input]');
  const out = box.querySelector('[data-apts-pc-result]');
  const value = input.value.trim();
  const city = `At checkout choose <strong>${box.dataset.city}</strong>.`;
  const other = `At checkout choose <strong>${box.dataset.out}</strong>.`;
  out.className = 'apts-pc__result';
  box.towns ??= parse(JSON.parse(box.querySelector('[data-apts-pc-codes]').textContent));

  if (/^\d+$/.test(value)) {
    if (value.length < 4) { out.textContent = ''; return; }
    const n = Number(value);
    const hits = box.towns.filter((t) => t.ranges.some((r) => n >= r.a && n <= r.b)).map((t) => t.city);
    out.classList.add(hits.length ? 'is-city' : 'is-out');
    out.innerHTML = hits.length
      ? `${value} is a major city centre street code (${hits.slice(0, 4).join(', ')}). ${city}`
      : `${value} is not a major city centre street code. ${other}`;
    return;
  }

  const key = value.toLowerCase().replace(/[^a-z0-9]/g, '');
  if (key.length < 3) { out.textContent = ''; return; }
  const hits = box.towns.filter((t) => t.key.startsWith(key));
  out.classList.add(hits.length ? 'is-city' : 'is-out');
  out.innerHTML = hits.length
    ? `${hits.slice(0, 4).map((t) => t.city).join(', ')} ${hits.length > 1 ? 'are' : 'is a'} major city centre${hits.length > 1 ? 's' : ''}. ${city} Check your street code to be sure.`
    : `"${value.replace(/[<>&"]/g, '')}" is not on our major city centre list. ${other} Try your street code to be sure.`;
};

document.addEventListener('input', (e) => {
  const box = e.target.closest?.('[data-apts-pc]');
  if (box && e.target.matches('[data-apts-pc-input]')) check(box);
});